export default __webpack_public_path__ + "static/media/firefox.efda5897.svg";